import { createContext, useContext } from 'react';

import type { RedcatAnalyticsStore } from './types/store';

const noop = () => undefined;

// Default store: every method is a no-op until a configured provider supplies a real one.
export const defaultStore: RedcatAnalyticsStore = {
  isConfigured: false,
  track: noop,
  page: noop,
  identify: noop,
  alias: noop,
  group: noop,
  updateContext: noop,
  reset: noop,
};

export const RedcatAnalyticsContext = createContext<RedcatAnalyticsStore | null>(null);

export function useRedcatAnalytics(): RedcatAnalyticsStore {
  const store = useContext(RedcatAnalyticsContext);
  if (!store) {
    throw new Error('useRedcatAnalytics must be used within a RedcatAnalyticsProvider');
  }
  return store;
}
